import { EmploymentPoliciesFull } from "./careers/EmploymentPolicies";

export default function EmploymentPoliciesPage() {
  return (
    <main className="min-h-[calc(100vh-4rem)] bg-white" data-testid="employment-policies-page">
      <div className="mx-auto max-w-4xl px-6 py-16 lg:px-10 lg:py-20">
        <EmploymentPoliciesFull />
      </div>
    </main>
  );
}